<mat-card class="login-card">
  <div class="brand">
    <div class="logo">
      <img src="assets/images/logo.png" alt="Tandas HN Logo" />
    </div>
    <div class="title">Tand HN</div>
    <div class="subtitle">Inicia sesión para continuar</div>
  </div>

  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <!-- USUARIO -->
    <mat-form-field appearance="outline" class="full">
      <mat-label>Usuario</mat-label>
      <input
        matInput
        formControlName="username"
        placeholder="Ingresa tu usuario"
      />
      <mat-icon matSuffix>person</mat-icon>
      @if (
        loginForm.get("username")?.touched &&
        loginForm.get("username")?.errors?.["minlength"]
      ) {
        <mat-error>Mínimo 4 caracteres</mat-error>
      }
    </mat-form-field>

    <!-- CONTRASEÑA -->
    <mat-form-field appearance="outline" class="full">
      <mat-label>Contraseña</mat-label>
      <input
        matInput
        formControlName="password"
        [type]="hidePassword ? 'password' : 'text'"
        placeholder="Ingresa tu contraseña"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="hidePassword = !hidePassword"
        tabindex="-1"
      >
        <mat-icon>{{
          hidePassword ? "visibility" : "visibility_off"
        }}</mat-icon>
      </button>
      @if (
        loginForm.get("password")?.touched &&
        loginForm.get("password")?.errors?.["minlength"]
      ) {
        <mat-error>Mínimo 6 caracteres</mat-error>
      }
    </mat-form-field>

    <button
      mat-flat-button
      class="btn"
      type="submit"
      [disabled]="loginForm.invalid || isLoading"
    >
      {{ isLoading ? "Cargando..." : "Iniciar Sesión" }}
    </button>
  </form>
  <div class="helper" style="margin-top: 15px; text-align: center">
    <a (click)="goForgotPassword()" style="cursor: pointer; color: #3f51b5"
      >¿Olvidaste tu contraseña?</a
    >
  </div>
</mat-card>
